module.exports = __webpack_public_path__ + "static/media/Moj-1-1.7e8be72d.webp";